<template>
  <v-menu
    v-model="menuVisible"
    z-index="500"
    :position-x="posX"
    :position-y="posY"
    absolute
    scale
    max-width="115"
    @input="$emit('answer',false)"
  >
    <v-card id="confirmation_card" class="d-flex flex-column pa-4" raised>
      <span class="text-h6">{{ title }}</span>
      <v-row class="mt-1" align="start">
        <v-btn
          id="confirmation_cancel"
          text
          color="grey"
          @click="$emit('answer', false)"
        >
          <v-icon>mdi-close-circle-outline</v-icon>
          {{ textNo }}
        </v-btn>

        <v-btn
          id="confirmation_accept"
          text
          color="error"
          @click="$emit('answer', true)"
        >
          <v-icon>{{ iconAgree }}</v-icon>
          {{ textAgree }}
        </v-btn>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: function() {
        return this.$t('confirmationMenu.title')
      }
    },
    textNo: {
      type: String,
      default: function() {
        return this.$t('confirmationMenu.textNo')
      }
    },
    textAgree: {
      type: String,
      default: function() {
        return this.$t('confirmationMenu.textAgree')
      }
    },
    iconAgree: {
      type: String,
      default: 'mdi-delete-outline'
    },
    posX: {
      type: Number,
      default: 1000
    },
    posY: {
      type: Number,
      default: 1000
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answer'],
  data() {
    return {
      menuVisible: this.visible
    }
  },
  watch: {
    visible(newVal) {
      this.menuVisible = newVal
    },
    menuVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  }
}
</script>

<style>
</style>
